import { useEffect, useState } from "react";
import React from "react";

import clientComponent from "../../../config/clientComponents";

const GenericFilter = ({
  filters,
  filterName,
  filtersState,
  setFiltersState,
  setSelectedInstitution,
  index,
  filtersKeys,
}) => {
  let itemDiv = "";
  let filterDiv = "";

  //----------- Styling filter layout depending on the filter (to change)
  if (filterName === Object.keys(filters)[1]) {
    itemDiv = "col-auto mr-2 mt-2";
    filterDiv = "row no-gutters mt-2";
  } else if (filterName === Object.keys(filters)[0]) {
    itemDiv = "col-6 px-1 mb-2";
    filterDiv = "row mx-n1 mt-2";
  }

  let typeFilters = [];
  const [isOpen, setIsOpen] = useState(true);

  const handleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  //--- Dynamic Import

  const FilterItem = clientComponent["FilterItem"];

  typeFilters = filters[filterName]["values"].map((filter) => {
    return (
      <FilterItem
        key={filterName+filter.id}
        filter={filter}
        filtersState={filtersState}
        filterName={filterName}
        setFiltersState={setFiltersState}
        itemDiv={itemDiv}
        filters={filters}
        setSelectedInstitution={setSelectedInstitution}
      />
    );
  });

  return (
    <React.Fragment key={filterName}>
      {filters[filterName]["title"] && (
        <div className={`generic-filter ${isOpen ? "open" : ""}`}>
          <div onClick={() => handleOpen()} className="generic-filter__title">
            {filters[filterName]["title"]}
          </div>
          <div className="items__wrapper" style={{ display: "none" }}>
            <div className={filterDiv}>{typeFilters}</div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
export default GenericFilter;
